import { IDashboardDataSourceProvider } from '@polygon/dashboard';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DashboardDataSourceService implements IDashboardDataSourceProvider {
	refresh$?: EventEmitter<void> = new EventEmitter<void>();

	mapAssetIcon(assetIcon: any): string {
		const divClass = 'homologous';
		switch (assetIcon?.assetIcon) {
			case '1':
				return `${divClass} icon-location_on`;
			case '2':
				return `${divClass} icon-equipment`;
			case '3':
				return `${divClass} icon-tools`;
			case '4':
				return `${divClass} icon-route`;
			default:
				return '';
		}
	}
}
